import FacebookIcon from '@/assets/social-icons/facebook.svg';
import InstagramIcon from '@/assets/social-icons/instagram.svg';
import TwitterIcon from '@/assets/social-icons/x.svg';
import LinkedinIcon from '@/assets/social-icons/linkedin.svg';
import YoutubeIcon from '@/assets/social-icons/youtube.svg';
import TiktokIcon from '@/assets/social-icons/tiktok.svg';
import ThreadsIcon from '@/assets/social-icons/threads.svg';
import PinterestIcon from '@/assets/social-icons/pinterest.svg';
import GoogleIcon from '@/assets/social-icons/google.svg';

export const PLATFORM_COLORS = {
  facebook: 'bg-blue-500',
  instagram: 'bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500',
  twitter: 'bg-sky-500',
  linkedin: 'bg-blue-700',
  pinterest: 'bg-red-500',
  google_my_business: 'bg-blue-600',
  threads: 'bg-black',
  tiktok: 'bg-black',
  youtube: 'bg-red-600',
} as const;

export const PLATFORM_ICONS = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  twitter: TwitterIcon,
  linkedin: LinkedinIcon,
  youtube: YoutubeIcon,
  tiktok: TiktokIcon,
  threads: ThreadsIcon,
  pinterest: PinterestIcon,
  google_my_business: GoogleIcon,
} as const;

export const PAGE_TYPE = {
  FACEBOOK: 1,
  INSTAGRAM: 2,
  TWITTER: 3,
  LINKEDIN: 4,
  PINTEREST: 5,
  GOOGLE_MY_BUSINESS: 8,
  THREADS: 9,
  TIKTOK: 10,
  YOUTUBE: 11,
} as const;

export const POST_TYPE = {
  COMMENT: 0,
  GALLERY: 1,
  VIDEO: 2,
} as const;

export const PLATFORM_DISPLAY_NAMES = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  twitter: 'X (Twitter)',
  linkedin: 'LinkedIn',
  youtube: 'YouTube',
  pinterest: 'Pinterest',
  google_my_business: 'Google My Business',
  threads: 'Threads',
  tiktok: 'TikTok',
} as const;

export const PLATFORM_CONFIGS = {
  facebook: { pageType: PAGE_TYPE.FACEBOOK, defaultPageName: 'Facebook Page' },
  instagram: { pageType: PAGE_TYPE.INSTAGRAM, defaultPageName: 'Instagram Account' },
  twitter: { pageType: PAGE_TYPE.TWITTER, defaultPageName: 'X (Twitter) Account' },
  linkedin: { pageType: PAGE_TYPE.LINKEDIN, defaultPageName: 'LinkedIn Page' },
  youtube: { pageType: PAGE_TYPE.YOUTUBE, defaultPageName: 'YouTube Channel' },
  pinterest: { pageType: PAGE_TYPE.PINTEREST, defaultPageName: 'Pinterest Board' },
  google_my_business: { pageType: PAGE_TYPE.GOOGLE_MY_BUSINESS, defaultPageName: 'Google Business' },
  threads: { pageType: PAGE_TYPE.THREADS, defaultPageName: 'Threads Account' },
  tiktok: { pageType: PAGE_TYPE.TIKTOK, defaultPageName: 'TikTok Account' },
} as const;

export const CALENDAR_TIPS = [
  "Drag posts between dates to reschedule • Click any post to view details",
  "Changes are temporary • Export to PDF, PNG, or CSV to save and share",
  "PDF exports include fillable approval forms with checkboxes and comments"
] as const;

export const WEEK_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

export function getStatusColor(status: string): string {
  switch(status) {
    case 'draft': return 'bg-gray-500';
    case 'approved': return 'bg-green-600';
    case 'scheduled': return 'bg-blue-600';
    case 'posted': return 'bg-purple-600';
    default: return 'bg-gray-500';
  }
}

export function getPostTypeBadgeColor(postType?: string): string {
  switch(postType) {
    case 'photo': return 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200';
    case 'video': return 'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-200';
    case 'link': return 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-200';
    case 'reel': return 'bg-pink-100 text-pink-700 dark:bg-pink-900 dark:text-pink-200';
    default: return 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300';
  }
}
